import ApiService from '../common/api.service';

import {
  FETCH_ABSENCES, ADD_ABSENCE, REMOVE_ABSENCE,
} from './actions.type';

import {
  SET_ERROR,
} from './mutations.type';


/* eslint-disable no-param-reassign */
/* eslint-disable no-shadow */

const state = {
};

const getters = {
};

const actions = {
  [FETCH_ABSENCES](context, data) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.post('rh/inasistencias', data)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, [response.data.message]);
        });
    });
  },
  [ADD_ABSENCE](context, data) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.post('rh/agregar_inasistencia', data)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, [response.data.message]);
        });
    });
  },
  [REMOVE_ABSENCE](context, data) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.post('rh/eliminar_inasistencia', data)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, [response.data.message]);
        });
    });
  },
};

const mutations = {
  [SET_ERROR](state, data) {
    state.alert = true;
    state.alertMessage = data;
    state.alertType = 'error';
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
